<template>
  <transition name="fade">
    <div class="backdrop" v-if="isShown" @click.self="exit">
      <div class="container">
        <div class="card">
          <button @click="exit" v-html="closeIcon"></button>
          <img :src="image" :alt="movie.title">
          <div class="details">
            <h1>{{movie && movie.title}}</h1>
            <p class="small">{{genres}} • {{runtime}} • Released on {{formatDate(movie.release_date)}}</p>
            <p class="small">
              <span v-show="movie.infos.imdbRating">Average vote: {{movie.infos.imdbRating}} • </span>
              <span v-show="movie.infos.rtRating">{{movie.infos.rtRating}} liked it</span>
            </p>
            <div class="list">
              <p v-show="movie.infos.director"><strong>Director:</strong> {{movie.infos.director}}</p>
              <p v-show="movie.infos.writer"><strong>Writer:</strong> {{movie.infos.writer}}</p>
              <p v-show="movie.infos.actors"><strong>Actors:</strong> {{movie.infos.actors}}</p>
              <p v-show="movie.infos.awards"><strong>Awards:</strong> {{movie.infos.awards}}</p>
            </div>
            <p class="plot--label"><strong>Plot:</strong></p>
            <p class="plot">{{movie.infos.plot}}</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { formatDate } from '../utils';
import feather from 'feather-icons';

export default {
  data() {
    return {
      closeIcon: feather.icons.x.toSvg(),
    };
  },
  computed: {
    image() {
      return this.movie.poster_path
        ? `https://image.tmdb.org/t/p/w342/${this.movie.poster_path}`
        : null;
    },
    isShown() {
      return this.$store.getters.getStatusMovieDetails;
    },
    movie() {
      return this.$store.getters.getMovieDetails;
    },
    genres() {
      return this.$store.getters.genresString(this.movie.genre_ids);
    },
    runtime() {
      return this.setRuntime();
    },
  },
  methods: {
    exit(event) {
      this.$store.dispatch('toggleMovieDetails');
    },
    setRuntime() {
      if (this.movie) {
        const time = this.movie.infos.runtime.match(/\d+/)[0];
        const hours = Math.floor(time / 60)
        const mins = time % 60;
        return `${hours}h ${mins}min`;
      }
    },
    formatDate(date) {
      const splitDate = date.split('-');
      const formatDate = new Date(Date.UTC(splitDate[0], splitDate[1], splitDate[2]));
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return formatDate.toLocaleString('en-US', options);
    }
  },
  watch: {
    isShown: (isShown) => {
      if (isShown) {
        document.documentElement.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflow = 'auto'
      }
    }
  },
  created() {
    this.setRuntime();
  },
};
</script>

<style lang="scss" scoped>
.backdrop {
  position: fixed;
  max-width: 100%;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba($color: #000000, $alpha: 0.7);
}

.container {
  max-height: 500px;
}

.card {
  display: flex;
  position: relative;
  max-height: 500px;
  margin: 60px auto 30px;
  border-radius: 6px;
  box-shadow: $shadow-level-2;
  background-color: white;
}

img {
  max-height: 100%;
  max-width: 342px;
  display: none;
  flex: 1;
  border-radius: 6px 0 0 6px;

  @media (min-width: $md) {
    display: block;
    flex: 1;    
  }
}


.details {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 15px;

  h1 {
    margin-bottom: 5px;
  }
}

.plot {
  margin-bottom: 15px;

  &--label {
    margin-bottom: 2px;
  }
}

p {
  font-size: 16px;
  margin: 6px 0;
}

.small {
  margin: 3px 0;
  color: #777777;
  font-size: 14px;
}

.list {
  margin: 20px 0;
}

button {
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  font-size: 2em;
  color: $primary-color;
  background-color: transparent;
  transition: transform 0.4s;

  @media (min-width: $md) {
    &:hover {
      transform: rotate(180deg);
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.15s ease-in;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
